import { User } from "@/types";
import { apiClient } from "@/lib/apiClient";

/**
 * Authentication Service
 * Handles all authentication-related API calls
 */
export const authApi = {
  /**
   * Fetch current user profile
   */
  getProfile: async (): Promise<User> => {
    return apiClient.get<User>("/api/auth/profile");
  },

  /**
   * Logout current user
   */
  logout: async (): Promise<void> => {
    return apiClient.post<void>("/api/auth/logout");
  },

  /**
   * Initiate Google OAuth login
   * Redirects to Google OAuth page
   */
  initiateGoogleLogin: () => {
    // A full-page redirect bypasses apiClient, so prefix the API origin explicitly:
    // relative "/api/..." only works in dev where Vite proxies it — on static hosting it 404s.
    window.location.href = `${import.meta.env.VITE_API_URL || ""}/api/auth/google`;
  },
};
